/* Email signups straight to Klaviyo's client subscribe API (not Shopify's customer
   form, whose hCaptcha blocks submits). Markup contract:
   <form data-klaviyo-subscribe data-klaviyo-company data-klaviyo-list data-klaviyo-source>
     input[type=email]; [data-klaviyo-error] (message); [data-klaviyo-done] (success);
     optional [data-klaviyo-fields] (hidden on success); optional data-klaviyo-properties
     (JSON object merged into the profile properties). */
(function () {
  document.addEventListener('input', function (ev) {
    var t = ev.target, form = t.closest && t.closest('[data-klaviyo-subscribe]');
    if (!form || !t.matches('input[type="email"]')) return;
    t.removeAttribute('aria-invalid');
    var e = form.querySelector('[data-klaviyo-error]');
    if (e && e.dataset.flDefault !== undefined) { e.hidden = true; e.textContent = e.dataset.flDefault; }
  });
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form.matches || !form.matches('[data-klaviyo-subscribe]')) return;
    ev.preventDefault();
    var d = form.dataset, input = form.querySelector('input[type="email"]');
    var err = form.querySelector('[data-klaviyo-error]'), done = form.querySelector('[data-klaviyo-done]');
    var fields = form.querySelector('[data-klaviyo-fields]');
    var email = input && input.value.trim();
    if (!err) {
      err = document.createElement('div'); err.className = 'fl-form-msg fl-form-msg--error'; err.setAttribute('role', 'alert');
      err.setAttribute('data-klaviyo-error', ''); err.hidden = true; form.appendChild(err);
    }
    if (err.dataset.flDefault === undefined) err.dataset.flDefault = err.textContent;
    err.textContent = err.dataset.flDefault; err.hidden = true;
    if (input) input.removeAttribute('aria-invalid');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      err.textContent = 'Please enter a valid email address.'; err.hidden = false;
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
      return;
    }
    if (!d.klaviyoCompany || !d.klaviyoList) { err.hidden = false; return; }
    var props = {}; try { props = JSON.parse(d.klaviyoProperties || '{}'); } catch (e) {}
    var btn = form.querySelector('button[type="submit"]'); if (btn) btn.disabled = true;
    var body = { data: { type: 'subscription', attributes: {
      custom_source: d.klaviyoSource || 'shopify',
      profile: { data: { type: 'profile', attributes: {
        email: email,
        properties: Object.assign({ signup_source: 'website', signup_page: location.pathname }, props),
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      } } } },
      relationships: { list: { data: { type: 'list', id: d.klaviyoList } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(d.klaviyoCompany), {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2025-07-15' }, body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + r.status);
      if (fields) fields.hidden = true; else form.querySelectorAll('input,button').forEach(function (el) { el.hidden = true; });
      if (done) done.hidden = false;
      form.dispatchEvent(new CustomEvent('klaviyo:subscribed', { bubbles: true }));
    }).catch(function () {
      if (btn) btn.disabled = false;
      if (err) err.hidden = false;
    });
  });
})();
